import { useDispatch, useStore, useSelector } from 'react-redux';

export default {
  useDispatch,
  useStore,
  useSelector
};
